import React, { useState } from "react";

export default function PdfViewer({pdfUrl}) {
  const [loading, setLoading] = useState(true);
console.log(` the pdf file involve ${pdfUrl}`)
//  const pdfUrl = "https://jisapi.justwebtech.com/resources/REF002132025/661-Notice%20of%20Petition.pdf";
const onLoad=()=>{
  console.log('its loaded now');

   setLoading(false);
}
  return (
    <div style={{ position: "relative", height: "100%" }}>
      {loading && (
        <div style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 10
        }}>
          <div style={{background:'var(--primary)', padding:16, color:'var(--background)'}}><div className="spinner"></div> Loading document... </div>
        </div>
      )}

      <iframe
        src={pdfUrl}
        width="100%"
        height="100%"
        style={{ border: "none" }}
        onLoad={onLoad}
      />
    </div>
  );
}